import { Component, OnInit } from '@angular/core';
import {Slider} from '../../models/slider';
import {Router} from '@angular/router';
import {SliderService} from '../../services/slider.service';
import {BaseService} from '../../base.service';

@Component({
  selector: 'app-slider-list',
  templateUrl: './slider-list.component.html',
  styleUrls: []
})
export class SliderListComponent implements OnInit {

  private titleComponent: string;
  private titlePanel: string;
  private sliders: Slider[];
  private sliderId: number;

  constructor(
    private router: Router,
    private service: SliderService,
    private baseService: BaseService
  ) {}

  ngOnInit() {
    this.titleComponent = 'Sliders';
    this.titlePanel = 'Lista de Sliders';
    this.baseService.changedComponentName(this.titleComponent);

    this.list();
  }

  list() {
    this.service.list().subscribe(data => {
      if (data) {
        console.log(data);
        this.sliders = data;
      }
    });
  }

  get(event, id: number) {
    const link = ['/dashboard/sliders', id];
    this.router.navigate(link);
  }
}



// WEBPACK FOOTER //
// D:/padriana/gorent-panel/src/app/dashboard/slider/slider-list.component.ts